import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TermsComponent } from './components/terms/terms.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ScenarioOneComponent } from './components/dashboard/scenario-one/scenario-one.component';
import { ScenarioOneResults } from './components/dashboard/scenario-one/scenario-one-results/scenario-one-results.component';
import { ScenarioTwoComponent } from './components/dashboard/scenario-two/scenario-two.component';
import { ScenarioTwoResultsComponent } from './components/dashboard/scenario-two/scenario-two-results/scenario-two-results.component';
import { ScenarioThreeComponent } from './components/dashboard/scenario-three/scenario-three.component';
import { ScenarioThreeResultsComponent } from './components/dashboard/scenario-three/scenario-three-results/scenario-three-results.component';
import { ScenarioFourComponent } from './components/dashboard/scenario-four/scenario-four.component';
import { ScenarioFourthResultsComponent } from './components/dashboard/scenario-four/scenario-fourth-results/scenario-fourth-results.component';
import { ScenarioFiveComponent } from './components/dashboard/scenario-five/scenario-five.component';
import { ScenarioSixComponent } from './components/dashboard/scenario-six/scenario-six.component';
import { ScenarioSevenComponent } from './components/dashboard/scenario-seven/scenario-seven.component';
import { ScenarioEightComponent } from './components/dashboard/scenario-eight/scenario-eight.component';
import { ScenarioNineComponent } from './components/dashboard/scenario-nine/scenario-nine.component';
import { ScenarioTenComponent } from './components/dashboard/scenario-ten/scenario-ten.component';
import { AboutProjectComponent } from './components/about-project/about-project.component';

//guards
import { AuthGuard } from '../common/guards/auth.guard';
import { NotFoundComponent } from './not-found/not-found.component';
import { ScenarioFiveResultsComponent } from './components/dashboard/scenario-five/scenario-five-results/scenario-five-results.component';

export const antiFraudRoutes: Routes = [
	{
		path: '',
		component: DashboardComponent,
		canActivate: [AuthGuard],
		children: [
			{
				path: '',
				redirectTo: 'scenario-one',
				pathMatch: 'full'
			},
			{
				path: 'scenario-one',
				component: ScenarioOneComponent
			},
			{
				path: 'scenario-one-results/:personalId',
				component: ScenarioOneResults
			},
			{
				path: 'scenario-two',
				component: ScenarioTwoComponent
			},
			{
				path: 'scenario-two-results/:personalId',
				component: ScenarioTwoResultsComponent
			},
			{
				path: 'scenario-three',
				component: ScenarioThreeComponent
			},
			{
				path: 'scenario-three-results/:id1',
				component: ScenarioThreeResultsComponent
			},
			{
				path: 'scenario-three-results/:id1/:id2',
				component: ScenarioThreeResultsComponent
			},
			{
				path: 'scenario-three-results/:id1/:id2/:id3',
				component: ScenarioThreeResultsComponent
			},
			{
				path: 'scenario-three-results/:id1/:id2/:id3/:id4',
				component: ScenarioThreeResultsComponent
			},
			{
				path: 'scenario-three-results/:id1/:id2/:id3/:id4/:id5',
				component: ScenarioThreeResultsComponent
			},
			{ path: 'scenario-four', component: ScenarioFourComponent },
			{
				path: 'scenario-fourth-results/:registrationPlatesVinNumber',
				component: ScenarioFourthResultsComponent
			},
			{ path: 'scenario-five', component: ScenarioFiveComponent },
			{
				path: 'scenario-fifth-results/:registrationPlates/:vinNumber',
				component: ScenarioFiveResultsComponent
			},
			{ path: 'scenario-six', component: ScenarioSixComponent },
			{ path: 'scenario-seven', component: ScenarioSevenComponent },
			{ path: 'scenario-eight', component: ScenarioEightComponent },
			{ path: 'scenario-nine', component: ScenarioNineComponent },
			{ path: 'scenario-ten', component: ScenarioTenComponent }
		]
	},

	{
		path: 'terms',
		component: TermsComponent
	},
	{
		path: 'about-project',
		component: AboutProjectComponent
	},
	{
		path: '**',
		component: NotFoundComponent
	}
];

@NgModule({
	imports: [RouterModule.forRoot(antiFraudRoutes)],
	exports: [RouterModule]
})
export class AntiFraudRoutingModule {}
